import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";

export function ChangeDueModal({ changeDueAmount, changeDueCountdown, modalDuration, onDone, styles }) {
  const { headerFont, headerWeight, totalFont, totalSize, totalWeight, exactCashFont, exactCashSize, exactCashWeight } = styles;

  return createPortal(
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center" style={{ zIndex: 9999, pointerEvents: "auto" }} data-testid="change-due-modal">
      <div className="bg-white rounded-2xl p-8 text-center shadow-2xl min-w-[320px]" style={{ fontFamily: `${headerFont}, sans-serif` }}>
        <h2 className="text-2xl font-bold text-zinc-800 mb-2" style={{
          fontFamily: `${headerFont}, sans-serif`,
          fontWeight: headerWeight
        }}>Change Due</h2>
        <div className="my-6" style={{
          fontFamily: `${totalFont}, sans-serif`,
          fontSize: `${Math.round(parseInt(totalSize) * 2)}px`,
          fontWeight: totalWeight,
          color: '#16a34a'
        }}>
          ${changeDueAmount.toFixed(2)}
        </div>
        {changeDueCountdown > 0 && (
          <div className="mb-4">
            <div className="text-sm text-zinc-500 mb-2">Auto-closing in</div>
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-zinc-100 text-xl font-bold text-zinc-700 tabular-nums">
              {changeDueCountdown}
            </div>
            <div className="mt-2 mx-auto w-48 bg-zinc-200 rounded-full h-1.5">
              <div
                className="bg-green-500 h-1.5 rounded-full transition-all duration-1000 ease-linear"
                style={{ width: `${(changeDueCountdown / (modalDuration || 5)) * 100}%` }}
              />
            </div>
          </div>
        )}
        <Button
          className="h-14 px-12 bg-green-600 hover:bg-green-700 text-white"
          style={{
            fontFamily: `${exactCashFont}, sans-serif`,
            fontSize: `${exactCashSize}px`,
            fontWeight: exactCashWeight
          }}
          onClick={onDone}
          data-testid="change-due-done-btn"
        >
          Done
        </Button>
      </div>
    </div>,
    document.body
  );
}
